




import { Component } from 'vue-property-decorator'

// mixins
import VKIDMixin from '@/mixins/VKIDMixin'

@Component
export default class VKAuth extends VKIDMixin {
  private mounted() {
    this.vkPayment()
  }
}
